import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import TopNav from "../TopNav";
import Notifications from "../Notifications";
import NavHeader2 from "../NavHeader2";
import Sidebar from "../Sidebar";
import Footer from "../Footer";
import Loaders from "../Loaders";
import BreadcrumTop from "../BreadcrumTop";
import { getToken } from "../../../utils/getToken";
import { API_ROUTES } from "../../../utils/constants";
import { apiFetch } from "../../../utils/apiFetch";

export default function DeleteMarketer(props) {
  const { isLoaded } = props;

  const [id, setId] = useState("");
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [pid, setPid] = useState("");
  const [companyId, setCompanyId] = useState("");
  const [url, setUrl] = useState("");
  const [loading, setLoading] = useState(false);

  const location = useLocation();
  const navigate = useNavigate();
  const rowData = location.state?.rowData;
  // console.log("data to delete", rowData);

  useEffect(() => {
    if (rowData) {
      //   console.log("company id", rowData.companyId);
      // console.log("row date fro dlete", rowData);
      setId(rowData.id || "");
      setName(rowData.name || "");
      setEmail(rowData.email || "");
      setPid(rowData.pId || "");
      setCompanyId(rowData.companyId || "");
      setUrl(rowData.url || "");
      // Save to localStorage for use later
      // localStorage.setItem(
      //   "companyVASData",
      //   JSON.stringify({
      //     id: rowData.companyId,
      //     companyName: rowData.companyName,
      //   })
      // );
    }
  }, [rowData]);

  // Validation function
  const validateForm = () => {
    if (!name || !email || !pid || !url) {
      Swal.fire({
        title: "Error",
        text: "All fields are required.",
        icon: "error",
      });
      return false;
    }
    return true;
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) {
      return;
    }

    const token = getToken();
    if (!token) {
      Swal.fire({
        title: "Error",
        text: "Please log in first.",
        icon: "error",
      });

      // Clear specific items from local storage
      localStorage.removeItem("companyName");
      localStorage.removeItem("userVASData");

      // Redirect to the login page
      navigate("/login");
      return;
    }

    const formData = {
      name,
      pId: pid,
      url,
      email,
      companyId,
      id,
    };
    // console.log("form data for delete", formData);
    setLoading(true);
    try {
      const url = `${API_ROUTES.DELETE_COMPANY_MARKETER}/${encodeURIComponent(
        companyId
      )}/${encodeURIComponent(id)}`;
      const response = await apiFetch(url, {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });

      if (!response.ok) {
        const errorMessages = {
          400: "Bad Request. Please check your input.",
          401: "Unauthorized. Please log in again.",
          404: "Not Found. The requested resource could not be found.",
          500: "Internal Server Error. Please try again later.",
          503: "Service Unavailable. Please try again later.",
        };

        throw new Error(errorMessages[response.status] || "Unexpected error.");
      }

      // const responseJSON = await response.json();

      if (response.ok) {
        Swal.fire({
          title: "Success",
          text: "Marketer deleted successfully.",
          icon: "success",
        }).then(() => {
          const companyData = localStorage.getItem("companyVASData");
          const parsedData = companyData ? JSON.parse(companyData) : null;

          //Add your log here to confirm what you're sending back
          // console.log("Navigating back with data:", parsedData);

          navigate("/marketers", {
            state: {
              rowData: {
                id: parsedData?.id,
                companyName: parsedData?.companyName,
              },
            },
          });
        });
      } else {
        Swal.fire({
          title: "Error",
          text: "Unable to delete marketer.",
          icon: "error",
        });
      }
    } catch (error) {
      Swal.fire({
        title: "Error",
        text: error.message,
        icon: "error",
      });
    } finally {
      setLoading(false);
    }
  };

  // const companyData = localStorage.getItem("companyVASData");
  // const parsedData = companyData ? JSON.parse(companyData) : null;

  const companyDataString =
    localStorage.getItem("companyVASData") ||
    localStorage.getItem("userVASData");

  const parsedData = companyDataString ? JSON.parse(companyDataString) : null;

  return (
    <>
      {/* <Loaders isLoaded={isLoaded} /> */}

      <div id="main-wrapper" className={isLoaded ? "show" : ""}>
        <TopNav />
        <Notifications />
        <NavHeader2 />
        <Sidebar />

        <div className="content-body">
          <div className="container-fluid">
            <BreadcrumTop title="Delete Marketer" />

            <div className="row">
              <div className="col-xl-7 col-lg-10 col-md-10 mx-auto">
                <div className="card">
                  <div className="card-body">
                    <div className="basic-form">
                      <form onSubmit={handleSubmit}>
                        <div className="mb-2 row">
                          <div className="col-sm-10 offset-sm-2">
                            <div
                              className="alert alert-danger text-uppercase"
                              role="alert"
                            >
                              <b>Are you sure you want to delete!</b>
                            </div>
                          </div>
                        </div>
                        <input
                          type="hidden"
                          name="companyId"
                          value={companyId}
                        />
                        <input type="hidden" name="id" value={id} />
                        <div className="mb-3 row">
                          <label className="col-sm-2 col-form-label">
                            Name *
                          </label>
                          <div className="col-sm-10">
                            <input
                              type="text"
                              name="name"
                              value={name}
                              readOnly
                              //   onChange={(e) => setName(e.target.value)}
                              className="form-control"
                              placeholder="Enter name"
                              required
                            />
                          </div>
                        </div>

                        <div className="mb-3 row">
                          <label className="col-sm-2 col-form-label">
                            Email
                          </label>
                          <div className="col-sm-5">
                            <input
                              type="email"
                              name="email"
                              value={email}
                              readOnly
                              //   onChange={(e) => setEmail(e.target.value)}
                              className="form-control"
                              placeholder="Enter email"
                              required
                            />
                          </div>
                          <label className="col-sm-1 col-form-label">PID</label>
                          <div className="col-sm-4">
                            <input
                              type="text"
                              name="pId"
                              value={pid}
                              readOnly
                              //   onChange={(e) => setPid(e.target.value)}
                              className="form-control"
                              placeholder="Enter PID"
                              // required
                            />
                          </div>
                        </div>

                        <div className="mb-3 row">
                          <label className="col-sm-2 col-form-label">URL</label>
                          <div className="col-sm-10">
                            <input
                              type="text"
                              name="url"
                              value={url}
                              //   onChange={(e) => setUrl(e.target.value)}
                              readOnly
                              className="form-control"
                              placeholder="Enter company URL"
                              // required
                            />
                          </div>
                        </div>

                        <div className="mb-3 mt-4 row">
                          <div className="col-sm-12 d-flex justify-content-end">
                            <button
                              type="submit"
                              className="btn btn-danger m-1 "
                              disabled={loading}
                            >
                              {loading ? (
                                <span
                                  className="spinner-border spinner-border-sm"
                                  role="status"
                                  aria-hidden="true"
                                ></span>
                              ) : (
                                "Delete Marketer"
                              )}
                            </button>
                            {/* <Link
                              to="/marketers"
                              state={{ rowData }}
                              className="btn btn-dark m-1 "
                            >
                              Go Back
                            </Link> */}
                            <Link
                              to="/marketers"
                              state={{
                                rowData: {
                                  id: parsedData?.id,
                                  companyName: parsedData?.companyName,
                                },
                              }}
                              className="btn btn-dark m-1"
                            >
                              Go Back
                            </Link>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <Footer />
      </div>
    </>
  );
}
